import * as $ from 'jquery';
import { recaptchaObject } from "./recaptcha";

export class externalProductForm {
	private formEl:any = $('#contact-form-lava-product');

	initForm():void {
		$('.captcha-error-text').hide();
		let submitBtn:any = $("#contact-reservation-form-submit");
		submitBtn.on('click',function() {		
			if(grecaptcha.getResponse().length == 0) {
				$('.captcha-error-text').show();
			}
			else {
				$('.captcha-error-text').hide();
				$('#contact-reservation-form-submit').attr("disabled", true);
				$('#contact-reservation-form-submit').css("pointer-events","none");
				var win = <HTMLIFrameElement>document.getElementById('theIframe');
				win.contentWindow.postMessage('submit', '*');
				setTimeout(function(){
					$('#contact-reservation-form-submit').attr("disabled", false);
					$('#contact-reservation-form-submit').css("pointer-events","unset");
				}, 4000);
				$("#theIframe").on("load", function () {
					$(window).scrollTop(1000);
					$("#contact-form-lava-product").hide();
					$(".contact-iframe-booking--success").show();
				})
			}
    });
	}

	initRecaptcha():any {
		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'register-form-product-recaptcha',
			cb: 'recaptchaProductSuccess',
			cbObj: 	function (response:any) {
								(document.getElementById('register-form-product-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'contact-product--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

}

let scope:Element = document.querySelector('#contact-form-lava-product');
if (scope){
	try {
	let extprodform = new externalProductForm();

		extprodform.initRecaptcha();
		extprodform.initForm();
	} catch(e) {console.error(e);}
}
